import React, { useEffect, useState } from 'react';

function TypeComponent(props) {
  const { detail } = props;
  if (detail.version == 'A') {
    return <p>Standard</p>;
  }
  if (detail.version == 'B') {
    return <p>Mini</p>;
  }
  if (detail.version == 'C') {
    return <p>DataCam</p>;
  }
  return <p>{detail.version}</p>;
}

export default TypeComponent;
